(() => {
  const TOAST_SELECTOR =
    '[data-ct-wishlist-toast]';

  const TITLE_SELECTOR =
    '[data-ct-wishlist-toast-title]';

  const PRODUCT_SELECTOR =
    '[data-ct-wishlist-toast-product]';

  const MESSAGE_SELECTOR =
    '[data-ct-wishlist-toast-message]';

  const CLOSE_SELECTOR =
    '[data-ct-wishlist-toast-close]';

  const DISPLAY_DURATION = 3200;

  let hideTimer = null;

  function getToast() {
    return document.querySelector(TOAST_SELECTOR);
  }

  function hideToast() {
    const toast = getToast();

    if (!toast) {
      return;
    }

    window.clearTimeout(hideTimer);

    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden', 'true');
  }

  function showToast(detail = {}) {
    const toast = getToast();

    if (!toast) {
      return;
    }

    const titleElement = toast.querySelector(
      TITLE_SELECTOR
    );

    const productElement = toast.querySelector(
      PRODUCT_SELECTOR
    );

    const messageElement = toast.querySelector(
      MESSAGE_SELECTOR
    );

    const isAdded = Boolean(detail.isActive);
    const isProductPage = Boolean(
      detail.isProductPage
    );

    const productTitle =
      detail.productTitle || 'Product';

    const statusTitle = isProductPage
      ? isAdded
        ? 'Saved to wishlist'
        : 'Removed from wishlist'
      : isAdded
        ? toast.dataset.addedTitle ||
          'Added to wishlist'
        : toast.dataset.removedTitle ||
          'Removed from wishlist';

    const statusMessage = isAdded
      ? toast.dataset.addedMessage ||
        'Added to your wishlist.'
      : toast.dataset.removedMessage ||
        'Removed from your wishlist.';

    if (titleElement) {
      titleElement.textContent = statusTitle;
    }

    if (productElement) {
      productElement.textContent = productTitle;
    }

    if (messageElement) {
      messageElement.textContent = statusMessage;
    }

    toast.classList.toggle('is-added', isAdded);
    toast.classList.toggle(
      'is-removed',
      !isAdded
    );
    toast.classList.toggle(
      'is-product-feedback',
      isProductPage
    );

    /*
     * Reset animation when the customer clicks
     * multiple Wishlist buttons quickly.
     */
    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden', 'true');

    window.clearTimeout(hideTimer);

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        toast.classList.add('is-visible');
        toast.setAttribute('aria-hidden', 'false');
      });
    });

    hideTimer = window.setTimeout(() => {
      hideToast();
    }, DISPLAY_DURATION);
  }

  document.addEventListener(
    'ct:wishlist:toggled',
    (event) => {
      showToast(event.detail);
    }
  );

  document.addEventListener(
    'click',
    (event) => {
      const closeButton = event.target.closest(
        CLOSE_SELECTOR
      );

      if (!closeButton) {
        return;
      }

      hideToast();
    }
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Escape') {
        hideToast();
      }
    }
  );

  window.CTWishlistToast = {
    show: showToast,
    hide: hideToast,
  };
})();
